/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Event_Aria_LabelInputs */

const en_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event notes`)
};

const fr_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes d'evenement`)
};

const de_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsnotizen`)
};

const it_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note sull'evento`)
};

const ru_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечания к мероприятию`)
};

const es_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas del evento`)
};

const zh_cn2_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动笔记`)
};

const ja_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントノート`)
};

const hi_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना संबंधी नोट्स`)
};

const pt_pt2_notes_event_aria_label = /** @type {(inputs: Notes_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas do evento`)
};

/**
* | output |
* | --- |
* | "Event notes" |
*
* @param {Notes_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_event_aria_label = /** @type {((inputs?: Notes_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notes_event_aria_label(inputs)
	if (locale === "de") return de_notes_event_aria_label(inputs)
	if (locale === "it") return it_notes_event_aria_label(inputs)
	if (locale === "ru") return ru_notes_event_aria_label(inputs)
	if (locale === "es") return es_notes_event_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_notes_event_aria_label(inputs)
	if (locale === "ja") return ja_notes_event_aria_label(inputs)
	if (locale === "hi") return hi_notes_event_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_notes_event_aria_label(inputs)
	return en_notes_event_aria_label(inputs)
});